import { CanActivateFn, Router } from '@angular/router';
import { SettingsService } from '../services';
import { inject } from '@angular/core';


export const askaiGuardGuard: CanActivateFn = (route, state) => {
  const settingService = inject(SettingsService);
  const router = inject(Router);
  const isAskAiEnabled = settingService.aiChat;
  if(isAskAiEnabled)return true;
  else router.navigate(['/home']);
};
